import Api from '../baseApi';

export default {
  async fetch() {
    return await Api.get('/api-article/v1/deliveryProperty');
  }
}
